import React from 'react'
import { DpPreviewViewer, DpDescriptions } from '@/libs/components'
import DesensitizationBox, {
  IDesensiteProps,
} from '@/libs/components/DesensitizationBox'
import { FormTags } from './tags'

type CustomAppointmentDetailPropsType = {
  data?: any
  containerStyles?: React.CSSProperties
  nodeStyles?: React.CSSProperties
  isMask?: boolean
}
 
const FieldItemDom = (
  record: {
    id: number | string
    fieldName: string
    value: string
    fieldValue: string
    fieldCode: string
    fieldType: string
    izShow?: 0 | 1
  },
  index: number,
  options?: {
    isMask?: boolean
    maskData?: IDesensiteProps['data'] | null
  },
) => {
  if (record.izShow === 0) return <></> // 票务定制化字段，是否展示该字段
  const { isMask, maskData } = options || {}
  const maskValue = isMask ? maskData : (record.value || record.fieldValue)

  if (!isMask && record.value !== maskValue) {
    console.warn(`${record.fieldName}: 数据detailList与detailListObj不匹配`)
  }
  
  if (isMask) {
    return (
      <DpDescriptions.Item key={index} label={record.fieldName}>
        <DesensitizationBox data={maskValue || null} />
      </DpDescriptions.Item>
    )
  }

  switch (record.fieldType) {
    case 'upload': // 上传图片
    case 'custom-upload': // 上传图片
      return (
        <DpDescriptions.Item
          key={index}
          label={record.fieldName}
          itemStyles={{ flexDirection: 'column' }}
          labelStyles={{ paddingBottom: 6 }}
        >
          <DpPreviewViewer
            value={record?.fieldValue?.split(',')?.filter((_) => _) || []}
            _valueName={record?.value?.split(',')?.filter((_) => _) || []}
          />
        </DpDescriptions.Item>
      )
    case 'idNumber': // 证件信息，身份证之类
      return (
        <>
          <DpDescriptions.Item
            key={index}
            label={record.fieldName}
            labelStyles={{ paddingBottom: 6 }}
          >
            {record.value && `${JSON.parse(record.value)?.idTypeName || ''}`}
          </DpDescriptions.Item>
          <DpDescriptions.Item
            key={index + 'idNumber'}
            label={'证件号码'}
            labelStyles={{ paddingBottom: 6 }}
          >
            {record.value && `${JSON.parse(record.value)?.idNumber || ''}`}
          </DpDescriptions.Item>
        </>
      )
    default:
      return (
        <DpDescriptions.Item key={index} label={record.fieldName}>
          {record.value}
        </DpDescriptions.Item>
      )
  }
}

const RenderValue = (
  type: string,
  record: {
    id: number | string
    fieldName: string
    value: string
    fieldValue: string
    fieldCode: string
    izShow?: 0 | 1
  },
  index: number,
) => {
  if (record.izShow === 0) return <></> // 票务定制化字段，是否展示该字段
  switch (type) {
    case 'upload': // 上传图片
    case 'custom-upload': // 上传图片
      return (
        <DpDescriptions.Item
          key={index}
          label={record.fieldName}
          itemStyles={{ flexDirection: 'column' }}
          labelStyles={{ paddingBottom: 6 }}
        >
          <DpPreviewViewer
            value={record?.fieldValue?.split(',')?.filter((_) => _) || []}
            _valueName={record?.value?.split(',')?.filter((_) => _) || []}
          />
        </DpDescriptions.Item>
      )
    case 'idNumber': // 证件信息，身份证之类
      return (
        <>
          <DpDescriptions.Item
            key={index}
            label={record.fieldName}
            labelStyles={{ paddingBottom: 6 }}
          >
            {record.value && `${JSON.parse(record.value)?.idTypeName || ''}`}
          </DpDescriptions.Item>
          <DpDescriptions.Item
            key={index + 'idNumber'}
            label={'证件号码'}
            labelStyles={{ paddingBottom: 6 }}
          >
            {record.value && `${JSON.parse(record.value)?.idNumber || ''}`}
          </DpDescriptions.Item>
        </>
      )
    default:
      return (
        <DpDescriptions.Item key={index} label={record.fieldName}>
          {record.value}
        </DpDescriptions.Item>
      )
  }
}


const Detail: React.FC<CustomAppointmentDetailPropsType> = (props) => {
  const { data = [], isMask = false } = props
  // singleton始终显示groupName；multiple同一groupName只在第一条显示
  const seen = new Set<string>()
  return data?.map?.((v: any, _index: number) => {
    let borderRadius = '10px'
    let marginBottom = 10
    const pveNode = data?.[_index - 1]
    const nextNode = data?.[_index + 1]
    const start = (v?.groupName && nextNode?.nodeName && !nextNode?.groupName)
    const middle = (pveNode?.nodeName && (nextNode && !nextNode?.groupName) && !v?.groupName)
    const end = (pveNode?.nodeName && nextNode?.groupName && !v?.groupName && v?.nodeName)
    if (start) {
      borderRadius = '10px 10px 0 0'
      marginBottom = 0
    } else if (middle) {
      borderRadius = '0'
      marginBottom = 0
    } else if (end) {
      borderRadius = '0 0 10px 10px'
      marginBottom = 10
    }

    const isSingleton = v?.parentType === 'singleton'
    const showGroupTitle = isSingleton
      ? !!v?.groupName
      : (!!v?.groupName && !seen.has(v?.groupName))
    if (showGroupTitle) seen.add(v?.groupName)
    const showNodeName = v?.nodeName && v?.parentType !== 'singleton'

    if (!isMask) {
      return (
        <DpDescriptions
          title={showGroupTitle ? <>{v?.groupName}<FormTags value={v.tags} /></> : undefined}
          key={_index}
          containerStyles={props?.containerStyles}
          style={{
            borderRadius: borderRadius,
            marginBottom
          }}
          nodeName={showNodeName ? <span style={{ textAlign: 'left' }}>{v?.nodeName}<FormTags value={v.nodeTags} /></span> : undefined}
          nodeStyles={{
            ...props?.nodeStyles,
            borderWidth: showGroupTitle ? 0 : 1
          }}
          headerStyle={v?.headerStyle}
        >
          {(v?.fieldList || v?.detailList || []).map((m: any, index: number) => (
            <div key={index}>
              {RenderValue(m.fieldType, m, index)}
            </div>
          ))}
          {(v?.extraList || []).map((m: any, index: number) => (
            <div key={index + 'extraFieldList'}>
              {RenderValue(m.fieldType, m, index)}
            </div>
          ))}
        </DpDescriptions>
      )
    }

    const isSingleton2 = v?.parentType === 'singleton'
    const showGroupTitle2 = isSingleton2
      ? !!v?.groupName
      : (!!v?.groupName && !seen.has(`${v?.groupName}-mask`))
    if (showGroupTitle2) seen.add(`${v?.groupName}-mask`)
    const showNodeName2 = v?.nodeName && v?.parentType !== 'singleton'
    return (
      <DpDescriptions
        title={showGroupTitle2 ? <>{v?.groupName}<FormTags value={v.tags} /></> : undefined}
        key={_index}
        containerStyles={props?.containerStyles}
        style={{
          borderRadius: borderRadius,
          marginBottom
        }}
        nodeName={showNodeName2 ? <span style={{ textAlign: 'left' }}>{v?.nodeName}<FormTags value={v.nodeTags} /></span> : undefined}
        nodeStyles={{
          ...props?.nodeStyles,
          borderWidth: showGroupTitle2 ? 0 : 1
        }}
        headerStyle={v?.headerStyle}
      >
        {(v?.fieldList || v?.detailList || []).map((m: any, index: number) => (
          <div key={index}>
            {/** 按字段判断是否开启脱敏 */}
            {(() => {
              const isMask = v?.detailListObj
                ? m?.fieldCode in v?.detailListObj &&
                typeof v?.detailListObj?.[m?.fieldCode] === 'object'
                : false
              return FieldItemDom(m, index, {
                isMask,
                maskData: isMask
                  ? v?.detailListObj?.[m?.fieldCode] || null
                  : null,
              })
            })()}
          </div>
        ))}
        {(v?.extraList || []).map((m: any, index: number) => (
          <div key={index + 'extraFieldList'}>
            {(() => {
              const isMask = v?.detailListObj
                ? m?.fieldCode in v?.detailListObj &&
                typeof v?.detailListObj?.[m?.fieldCode] === 'object'
                : false
              return FieldItemDom(m, index, {
                isMask,
                maskData: isMask
                  ? v?.detailListObj?.[m?.fieldCode] || null
                  : null,
              })
            })()}
          </div>
        ))}
      </DpDescriptions>
    )
  })
}

export default Detail
